// extracted by css-extract-rspack-plugin
export default {"cls1":"AvatarCell-cls1_Lt4","cls2":"AvatarCell-cls2_Qt5 AvatarCell-cls1_Lt4"};